import axios from "axios"

const BaseURL = import.meta.env.VITE_BASEURL;

export const PostAuth = async (data) => {
    const response = await axios.post(`${BaseURL}/post/auth/login`, data);
    return response;
}